export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.oobeya.io/api/',
  apisBaseUrl: 'https://dev.oobeya.io/apis/',
  imageBaseUrl: 'https://dev.oobeya.io/api/',
  features: new Map([
    ['profiles', true],
    ['admin', true]
  ]),
  cryptoKey: 'kD&y(@!v8~_w,FDM',
  playground: false,
  isUserGuideActive: false,
};


